import { Badge } from "../ui/badge";

// Reconciliation rows carry the expiry and access the CRM calculates from memberships (what the app pushes to the
// turnstile). A CRM member who is not on the device has nothing on the hardware, so those values are only what will
// be synced once they are enrolled.

const BLOCKED_EXPIRY = "2000-01-01";
const PERMANENT_EXPIRY = "2099-12-31";

function expiryText(expiry) {
  if (expiry === BLOCKED_EXPIRY) return "Blocked (Expired)";
  if (expiry === PERMANENT_EXPIRY) return "Permanent Access";
  return expiry;
}

export function HardwareExpiry({ row }) {
  if (row.notOnDevice) {
    return (
      <div className="flex flex-col">
        <span className="text-muted-foreground">—</span>
        {row.effectiveExpiry && (
          <span className="text-[10px] font-normal text-muted-foreground">
            Once enrolled: {expiryText(row.effectiveExpiry)}
          </span>
        )}
      </div>
    );
  }
  if (row.effectiveExpiry === BLOCKED_EXPIRY) return <span className="text-rose-400">{expiryText(row.effectiveExpiry)}</span>;
  if (row.effectiveExpiry === PERMANENT_EXPIRY) return <span className="text-blue-400">{expiryText(row.effectiveExpiry)}</span>;
  if (row.effectiveExpiry) return <span className="text-foreground">{row.effectiveExpiry}</span>;
  return <span className="text-muted-foreground">—</span>;
}

const ACCESS_BADGES = {
  Allowed: ["Access Allowed", "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"],
  "Extended Access": ["Extended Access", "bg-purple-500/15 text-purple-400 border-purple-500/30"],
  "Grace Period": ["Grace Period", "bg-sky-500/15 text-sky-400 border-sky-500/30"],
  Blocked: ["Turnstile Blocked", "bg-rose-500/15 text-rose-400 border-rose-500/30"],
  "Staff Access": ["Staff Access", "bg-blue-500/15 text-blue-400 border-blue-500/30"],
};
const UNMAPPED_BADGE = ["Unmapped", "bg-amber-500/15 text-amber-400 border-amber-500/30"];
const NOT_ON_DEVICE_BADGE = ["Not on Device", "bg-secondary text-muted-foreground border-border"];

export function TurnstileStatus({ row }) {
  const [label, colors] = row.notOnDevice ? NOT_ON_DEVICE_BADGE : ACCESS_BADGES[row.accessStatus] || UNMAPPED_BADGE;
  return <Badge className={`${colors} text-[10px] font-normal`}>{label}</Badge>;
}
